import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminNotFoundComponent } from './admin-not-found/admin-not-found.component';



@NgModule({
  declarations: [AdminNotFoundComponent],
  imports: [
    CommonModule
  ],
  exports: [
    AdminNotFoundComponent
  ]
})
export class NotFoundModule { }
